import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import { includes } from 'lodash/fp';

import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';

dayjs.extend(duration);
dayjs.extend(relativeTime);

const text = {
    en: 'read',
    de: 'zu lesen',
    fr: 'pour lire',
    it: 'per leggere',
};

export default function readingTimeFilter(value, locale = 'en') {
    if (includes(locale, ['de', 'fr', 'it'])) {
        dayjs.locale(locale);
    }
    return `${ dayjs.duration(value * 1000).humanize() } ${ text[locale] ?? text.en }`;
}
